module.exports = __webpack_public_path__ + "static/img/server2.7e46870e.png";